import { CommImageNameComp } from "custom_modules/Members/CommonComponents";
import { useCallback, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button, Table } from "reactstrap";
import styled from "styled-components";

// Helper function to safely decode HTML entities using DOMParser
const decodeHtmlEntity = (text) => {
  if (!text) return text;
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/html");
  return doc.documentElement.textContent;
};

import avatar5 from "../../assets/img/avatar_5.svg";
import "../../assets/scss/custom.scss";
import FirstRoundLetterComp from "../../components/FirstRoundLetter/FirstRoundLetter";
import Select from "../../components/ReactSelectDropdown";
import {
  FirstWordRound,
  RoundLetterSection,
  TableText,
} from "../../styledComponents/common";
import { TableItem } from "../../styledComponents/teams";
import { currencySymbolMap } from "../../utils/currencies";
import { getTwoLetter } from "../../utils/helper";
import { OrgIconDiv } from "../Sidebar/popupStyles";
import DropdownStyle from "./DropdownStyle";
import OrganizationDeleteModal from "./OrganizationDeleteModal";
import { useDebouncedCallback } from "use-debounce";

const activeActionOptions = [
  {
    value: "edit",
    label: "Edit",
  },
  { value: "archive", label: "Archive" },
  { value: "delete", label: "Delete" },
];
const archivedActionOptions = [
  {
    value: "edit",
    label: "Edit",
  },
  { value: "unarchive", label: "Unarchive" },
  { value: "delete", label: "Delete" },
];

const TableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr 110px 160px 110px 140px;
  grid-column-gap: 4px;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.main.tableHeaderBackground};
  padding: ${({ padding,theme }) => padding || theme.table.tableHeaderPadding};
  // border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-radius: 10px 10px 0 0;
  @media (max-width: 1250px) {
    grid-template-columns: 220px 220px 110px 160px 110px 140px;
    grid-column-gap: 6px;
  }
`;

const TableBodyContainer = styled.div`
display: grid;
  grid-template-columns: 2fr 1.5fr 110px 160px 110px 140px;
  grid-column-gap: 4px;
  justify-content: space-between;
  padding: ${({ padding,theme }) => padding || theme.table.tableRowPadding};
  border-bottom: 1px solid ${({ isLastItem, theme }) => isLastItem ? "transparent" : theme.colors.border.tableBorder};
  // :nth-of-type(even) {
  //   background-color: #f8f9fc;
  // }
`;

export const RoundLetter = ({ text, backColor, size, fontSize, gap, org }) => {
  const currentOrg = localStorage.getItem("selected_organization_id");
  const decodedText = decodeHtmlEntity(text);
  return (
    <RoundLetterSection gap={gap}>
      <OrgIconDiv size={"42px"} selected={org === currentOrg}>
        <FirstWordRound backColor={backColor} size={size} fontSize={fontSize}>
          {getTwoLetter(decodedText)}
        </FirstWordRound>
      </OrgIconDiv>
      <TableText name>{decodedText}</TableText>
    </RoundLetterSection>
  );
};

const OrganizationsTable = ({
  toggleArchive,
  deleteOrganization,
  organizationsList,
  edit,
}) => {
  const [archiveItem, setArchiveItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);
  const currentOrg = localStorage.getItem("selected_organization_id");

  const handleToggleArchive = useCallback((org = null) => {
    setArchiveItem(org);
  }, []);

  const handleArchiveConfirm = useCallback(() => {
    toggleArchive(archiveItem);
    setArchiveItem(null);
  }, [archiveItem, toggleArchive]);

  const toggleDeleteItem = useCallback((org = null) => {
    setDeleteItem(org);
  }, []);

  const handleDeleteItemConfirm = useDebouncedCallback((password, agreed) => {
    if (deleteItem && deleteItem.id) {
      deleteOrganization({
        id: deleteItem.id,
        password,
        agreed,
      });
      setDeleteItem(null);
    }
  }, 500);

  const onActionChange = useCallback((action, org) => {
    switch (action) {
      case "edit":
        edit(org.id);
        break;
      case "archive":
      case "unarchive":
        handleToggleArchive(org);
        break;
      case "delete":
        toggleDeleteItem(org);
        break;
      default:
      // do nothing
    }
  }, [edit, handleToggleArchive, toggleDeleteItem]);

  return (
    <>
      <OrganizationDeleteModal
        isOpen={deleteItem !== null}
        organization={deleteItem}
        toggle={toggleDeleteItem}
        deleteOrg={handleDeleteItemConfirm}
      />
      <>
        <TableHeaderContainer>
          <TableItem>
            <TableText>Name</TableText>
          </TableItem>
          <TableItem>
            <TableText>Address</TableText>
          </TableItem>
          {/* <TableItem>
            <TableText>Type</TableText>
          </TableItem> */}
          <TableItem>
            <TableText>Code</TableText>
          </TableItem>
          <TableItem>
            <TableText>Timezone</TableText>
          </TableItem>
          {/* <TableItem>
            <TableText>Plan</TableText>
          </TableItem> */}
          <TableItem>
            <TableText>Currency</TableText>
          </TableItem>
          <TableItem>
            <TableText>Action</TableText>
          </TableItem>
        </TableHeaderContainer>
        {organizationsList &&
          organizationsList.map((org, i) => {
            const decodedOrgName = decodeHtmlEntity(org.name);
            return (
              <TableBodyContainer isLastItem={i === organizationsList.length - 1} key={i}>
                <TableItem>
                  {org.is_active ? (
                    <RoundLetterSection>
                      <OrgIconDiv
                        size={"42px"}
                        selected={org.id && org.id === currentOrg}
                      >
                        <FirstRoundLetterComp
                          size="34px"
                          fontSize="13px"
                          text={decodedOrgName}
                          backColor={i}
                          color={org.color || null}
                        />
                      </OrgIconDiv>
                      <TableText>{decodedOrgName}</TableText>
                    </RoundLetterSection>
                  ) : (
                    <RoundLetter
                      org={org.id}
                      size="34px"
                      fontSize="13px"
                      text={decodedOrgName}
                      backColor="#9eafc2"
                    />
                  )}
                </TableItem>
                <TableItem>
                  <TableText>{org.address || "-"}</TableText>
                </TableItem>
                {/* <TableItem>
                  <TableText name>
                    {(org.organization_type && org.organization_type.name) ||
                      "-"}
                  </TableText>
                </TableItem> */}
                <TableItem>
                  <CopyToClipboard text={org.code}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#6686A2",
                        color: "#fff",
                        borderRadius: "6px",
                        width: "90px",
                        height: "28px",
                      }}
                    >
                      {org.code}
                    </div>
                  </CopyToClipboard>
                </TableItem>
                <TableItem>
                  <TableText>{org.timezone}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>
                    {org.configuration && org.configuration.currency} (
                    {org.configuration &&
                      currencySymbolMap[org.configuration.currency]}
                    )
                  </TableText>
                </TableItem>
                {/* <TableItem className="org-plan">
                    <span
                      className="report-date-span"
                      style={{
                        background:
                          "linear-gradient(to right, #33ccae 0%, #00a99d 100%)",
                        color: "#fff",
                        fontWeight: "700",
                        fontSize: "13px",
                        minWidth: "240px",
                        height: "35px",
                      }}
                    >
                      {org.plan ? org.plan.name : "No plan"}
                    </span>
                  </TableItem> */}
                <TableItem>
                  <Select
                    isSearchable={false}
                    isDisabled={org.role !== "owner"}
                    value={null}
                    options={
                      org.is_active
                        ? activeActionOptions
                        : archivedActionOptions
                    }
                    onChange={e =>
                      org.role === "owner" && onActionChange(e.value, org)
                    }
                    placeholder="Actions"
                    styles={DropdownStyle(null)}
                  />
                </TableItem>
              </TableBodyContainer>
            );
          })}
      </>
      {archiveItem && (
        <SweetAlert
          title="Are you sure"
          showCancel
          onConfirm={handleArchiveConfirm}
          onCancel={() => handleToggleArchive()}
          confirmBtnText={archiveItem.is_active ? "Archive" : "Unarchive"}
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
        >
          {archiveItem.is_active
            ? "Do you really want to archive your organization?"
            : "Do you really want to make it active?"}
        </SweetAlert>
      )}
    </>
  );
};

export default OrganizationsTable;
